// Auto convert camelcase attrs into snake case params for backend
export const convertToSnakeCase = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (Array.isArray(obj[key])) {
      obj[key].forEach((item) => {
        Object.keys(item).forEach((key) => {
          snakeKey(item, key);
        });
      });
      snakeKey(obj, key);
    } else if (obj[key] && obj[key].constructor.name === 'Object') {
      Object.keys(obj[key]).forEach((k) => {
        snakeKey(obj[key], k);
      });
      snakeKey(obj, key);
    } else {
      snakeKey(obj, key);
    }
  });
};

const snakeKey = (obj, key) => {
  const camelToSnakeCase = key.replace(
    /[A-Z]/g,
    (letter) => `_${letter.toLowerCase()}`
  );
  if (camelToSnakeCase !== key) {
    obj[camelToSnakeCase] = obj[key];
    delete obj[key];
  }
};
// ==

export const camelCaseKeysToUnderscore = (obj) => {
  if (typeof obj !== 'object') return obj;

  for (const oldName in obj) {
    // Camel to underscore
    const newName = oldName.replace(/([A-Z])/g, function ($1) {
      return `_${$1.toLowerCase()}`;
    });

    // Only process if names are different
    if (newName !== oldName) {
      // Check for the old property name to avoid a ReferenceError in strict mode.
      if (obj.hasOwnProperty(oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }

    // Recursion
    if (typeof obj[newName] === 'object') {
      obj[newName] = camelCaseKeysToUnderscore(obj[newName]);
    }
  }
  return obj;
};
